<template>
  <div id="app">
    <main id="main-content" role="main" tabindex="-1">
      <router-view/>
    </main>
  </div>
</template>

<script>

import axios from 'axios';
import { pack, unpack } from './utils/pack';
export default {

  created() {

    // need to pass empty domain
    const data = { domain: '' };
    const packedData = pack(data);

    axios.post(process.env.VUE_APP_API_URL + 'config', {_data: packedData._data})
        .then(response => {

          const packedResult = response.data;
          const result = packedResult && packedResult._data ? unpack(packedResult) : packedResult;


          // already set default stuff of the application here
          this.setPageTitle(result.windowTitle);
          // https://favicomatic.com/
          let link = document.querySelectorAll("link[rel*='icon']");
          link[0].href = result.favIconUrls[0];
          link[1].href = result.favIconUrls[1];
          link[2].href = result.favIconUrls[2];
          link[3].href = result.favIconUrls[3];

          let styleSheet = document.querySelectorAll("link[type*='text/css']");
          styleSheet[1].href = '/themes/' + result.themeName + '.css?' + process.env.VUE_APP_VERSION;

        })
        .catch(e => {

          if (e.response && e.response.status == 503) {
            this.$router.replace('/notfound?maintenance=true');
            return;
          }

          this.$bugsnag.notify(e, {
          // Add custom metadata to the error report
          metaData: {
              custom: {
                componentName: 'App',
                currentRoute: this.$route.path,
              }
            }
          });

          this.$router.replace('/notfound?configError=true');
        });

  },


  data: function () {
    return {
      isMobile: false
    }
  },

  methods: {
    setPageTitle(title) {
      // Set document title with proper context for screen readers
      document.title = title || 'Gamification Platform';
      
      // Update the HTML lang attribute if needed based on locale
      const htmlElement = document.documentElement;
      if (this.$i18n && this.$i18n.locale) {
        htmlElement.setAttribute('lang', this.$i18n.locale);
      }
    },

    announceToScreenReader(message) {
      // Create or update ARIA live region for screen reader announcements
      let liveRegion = document.getElementById('aria-live-region');
      if (!liveRegion) {
        liveRegion = document.createElement('div');
        liveRegion.id = 'aria-live-region';
        liveRegion.setAttribute('aria-live', 'polite');
        liveRegion.setAttribute('aria-atomic', 'true');
        liveRegion.style.position = 'absolute';
        liveRegion.style.left = '-10000px';
        liveRegion.style.width = '1px';
        liveRegion.style.height = '1px';
        liveRegion.style.overflow = 'hidden';
        document.body.appendChild(liveRegion);
      }
      
      // Clear and set new message
      liveRegion.textContent = '';
      setTimeout(() => {
        liveRegion.textContent = message;
      }, 100);
    }
  },

  mounted() {
    // Make announceToScreenReader globally available
    this.$root.announceToScreenReader = this.announceToScreenReader;
  },
}

</script>

<style>

@import './assets/bootstrap.min.css';


html {
  width: 100%;
  height: 100%;
  display: table;
}

body {
  width: 100%;
  height: 100%;
  display: table-cell;
  font-family: "Nunito Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
}

html, body {
  margin: 0px;
  padding: 0px;
}

#app {
  height: 100%;
  min-height: 100%;
}

#main-content {
  height: 100%;
  min-height: 100%;
}

/* Focus indicators for better accessibility */
button:focus,
select:focus,
a:focus {
  outline: 2px solid #007bff;
  outline-offset: 2px;
}

/* Ensure interactive elements are large enough for touch */
button, 
.btn {
  min-height: 44px;
  min-width: 44px;
}

</style>
